import {
  Modal,
  Button,
  Box,
  InputLabel,
  Typography,
  Divider,
  IconButton,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(Modal)({
  height: '97%',
  width: '1140px',
  margin: 'auto'
});

export const ModalContent = styled(Box)({
  height: '100%',
  width: '100%',
  backgroundColor: 'white',
  outline: 'none',
  borderRadius: '4px',
  boxShadow:
    '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
  padding: '5px 70px',
  boxSizing: 'border-box'
});

export const CloseModalButton = styled(IconButton)({
  marginLeft: '100%',
  marginTop: '2%',
  marginBottom: '-16px',
  '&:hover': {
    background: 'white'
  }
});

export const CloseModalIcon = CloseIcon;

export const Title = styled(Typography)({
  textAlign: 'center',
  fontSize: '34px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '34px'
});

export const Subtitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '16px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '30px'
});

export const ModalBody = styled(Box)({
  marginTop: '10px',
  display: 'flex',
  width: '1022px',
  flexDirection: 'column',
  height: 'calc(100vh - 250px)',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '5px'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)'
  }
});

export const BodySection = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '20px',
  width: 'calc(100% - 26px)'
});

export const SectionColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

export const SectionDivider = styled(Divider)({
  marginTop: '25px',
  marginBottom: '15px',
  width: 'calc(100% - 26px)'
});

export const SectionDividerMarginTop = styled(Divider)({
  marginTop: '25px',
  width: 'calc(100% - 26px)'
});

export const DataLabel = styled(InputLabel)({
  color: '#757575',
  fontSize: '12px',
  fontFamily: 'Open Sans',
  marginLeft: '15px',
  marginTop: '5px'
});

export const InputStyle = {
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Open Sans',
  lineHeight: 1.4
};

export const ModalFooter = styled(Box)({
  position: 'absolute',
  display: 'flex',
  width: '1000px',
  height: '85px',
  bottom: '20px'
});

export const Spinner = styled(CircularProgress)({
  color: '#5F65F6',
  marginTop: '50vh',
  marginLeft: '50%'
});

export const CloseButton = styled(Button)({
  color: '#3F51B5',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '87px',
  height: '42px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  },
  marginLeft: '755px',
  marginRight: '15px',
  marginTop: '20px'
});

export const EditButton = styled(Button)({
  color: 'white',
  background: '#5F65F6',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '136px',
  height: '42px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#5F7EF5'
  },
  '&.Mui-disabled': {
    backgroundColor: '#ACADCF',
    color: '#FFF'
  },
  marginTop: '20px'
});

export const DataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '17px',
  marginBottom: '10px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  marginLeft: '15px',
  height: '38px',
  overflow: 'hidden'
});

export const BigDataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '17px',
  marginBottom: '28px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  marginLeft: '15px',
  height: '38px',
  overflow: 'hidden'
});
